import { useCallback, useState } from "react";
import { useRecoilState } from "recoil";
import { MouseButtonAtom } from "../utils/context";
import { useBoard } from "./useBoard";
export function useMouse() {
    var currentBoard = useBoard().currentBoard;
    var _a = useRecoilState(MouseButtonAtom), mouseButton = _a[0], setMouseButton = _a[1];
    var _b = useState(undefined), lastMousePosition = _b[0], setLastMousePosition = _b[1];
    var _c = useState('empty'), mouseSquareValue = _c[0], setMouseSquareValue = _c[1];
    var onMouseDown = useCallback(function (event) {
        var _a, _b;
        var lastPositionSquareValue = currentBoard.at((_a = lastMousePosition === null || lastMousePosition === void 0 ? void 0 : lastMousePosition.index) !== null && _a !== void 0 ? _a : 0);
        setMouseSquareValue(currentBoard.at((_b = lastMousePosition === null || lastMousePosition === void 0 ? void 0 : lastMousePosition.index) !== null && _b !== void 0 ? _b : 0));
        if (event.button === 0 && event.type === "mousedown") {
            setMouseButton("left");
            if (lastPositionSquareValue === 'filled') {
                setMouseSquareValue('empty');
            }
            else {
                setMouseSquareValue('filled');
            }
        }
        else if (event.button === 2 && event.type === "mousedown") {
            setMouseButton("right");
            if (lastPositionSquareValue === 'marked') {
                setMouseSquareValue('empty');
            }
            else {
                setMouseSquareValue('marked');
            }
        }
    }, [setMouseButton, currentBoard, setMouseSquareValue, lastMousePosition]);
    var onMouseUp = useCallback(function (event) {
        setMouseButton("none");
    }, [setMouseButton]);
    var onSquareMouseEnter = useCallback(function (location) {
        setLastMousePosition(location);
    }, [setLastMousePosition]);
    var onSquareMouseLeave = useCallback(function (location) {
        setLastMousePosition(undefined);
    }, [setLastMousePosition]);
    return {
        mouseButton: mouseButton,
        mouseSquareValue: mouseSquareValue,
        onMouseUp: onMouseUp,
        onMouseDown: onMouseDown,
        lastMousePosition: lastMousePosition,
        onSquareMouseEnter: onSquareMouseEnter,
        onSquareMouseLeave: onSquareMouseLeave,
    };
}
